// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"227":"41f989bf","232":"e9760b58","237":"13ddd711","526":"898ff334","845":"084f1ff6"}[chunkId] + ".chunk.js";
};